import type { SnsPostStatus, Platform } from '../api/types';

export const STATUS_LABELS: Record<SnsPostStatus, string> = {
  draft: '下書き',
  writing: '原稿作成中',
  photo_requested: '写真撮影依頼済',
  photo_received: '写真受領',
  ready: '投稿準備完了',
  posted: '投稿済',
};

export const STATUS_COLORS: Record<SnsPostStatus, string> = {
  draft: '#8c8c8c',
  writing: '#1677ff',
  photo_requested: '#fa8c16',
  photo_received: '#13c2c2',
  ready: '#52c41a',
  posted: '#722ed1',
};

export const PLATFORM_LABELS: Record<Platform, string> = {
  instagram: 'Instagram',
  line: 'LINE',
  facebook: 'Facebook',
};

export const PLATFORM_COLORS: Record<Platform, string> = {
  instagram: '#E1306C',
  line: '#00B900',
  facebook: '#1877F2',
};
